import { FunctionalComponent, h } from 'preact';
import Toggle from '../Toggle/Toggle';
import { ToggleContainer } from './InlineToggle.styles';

type Props = {
  checked: boolean;
  id?: string | number;
  isDisabled?: boolean;
  label?: string;
  labelledBy: string;
  onToggle: () => void;
};

const InlineToggle: FunctionalComponent<Props> = ({ checked, id, isDisabled = false, label, labelledBy, onToggle }) => {
  return (
    <ToggleContainer>
      <Toggle
        checked={checked}
        id={id}
        isDisabled={isDisabled}
        label={label}
        onToggle={onToggle}
        labelledBy={labelledBy}
      />
    </ToggleContainer>
  );
};

export default InlineToggle;
